import { connect } from "react-redux";
import { actions as recaptchaActions } from "./Recaptcha.redux";

import Recaptcha from "./Recaptcha.view";

const mapStateToProps = state => ({
  recaptchaLoaded: state.recaptchaLoaded,
});

const mapDispatchToProps = dispatch => ({
  handleRecaptchaLoaded: () => dispatch(recaptchaActions.handleLoaded()),
  handleRecaptchaLoading: () => dispatch(recaptchaActions.handleLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Recaptcha);
